import React from 'react';
import { Link } from 'react-router-dom';



const Banner = ({projectName}) => {

  return (
    <div>
      <div className="container-fluild overflow-hidden">
        <section className="nebopan">
          <div
            className="nebopan-banner-section"
            style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("/assets/images/maxresdefault-5.png")'}}
          >
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <p className=" centered-p">Devis de {projectName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      
    </div>
  )
}

export default Banner 